import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qa-toggle-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "qa-toggle-outer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "qa-toggle-inner" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      type: "checkbox",
      class: "qa-toggle"
    }, _ctx.$attrs, {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
    }), null, 16, _hoisted_2), [
      [_vModelCheckbox, _ctx.value]
    ]),
    _createElementVNode("label", {
      class: "qa-toggle-label",
      for: _ctx.id
    }, [
      _hoisted_4,
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 8, _hoisted_3)
  ]))
}